// Assign group roles
export * from "./assignGroupRoles.component";
export * from "./assignGroupRoles.service";



// WEBPACK FOOTER //
// ./src/app/modules/userHome/applicationAccess/assignGroupRoles/index.ts